<template>
  <div id="articledetail">
    <div v-wechat-title="$route.meta.title = this.title"></div>
    <article-head></article-head>
    <h3>{{articleData.title}}</h3>
    <div class="subtitle">
      <h6>{{articleData.from}}</h6>
      <span>{{articleData.time}}</span>
    </div>
    <div class="detail" v-html="articleData.content">
    </div>
    <article-foot :pageName="pageName" @listenLogin="showLogin"></article-foot>
    <i-login @listenShow="showLogin" v-show="loginShow"></i-login>
  </div>
</template>

<script>
import articleHead from '../share/header/articleHead'
import articleFoot from '../share/footer/articleFoot'
import iLogin from '../share/popup/login/iLogin'
export default {
  name: 'ArticleDetail',
  data () {
    return {
      newsId: this.$route.params.new_id ? this.$route.params.new_id : 3,
      articleData: {},
      loginShow: 0,
      title: '',
      pageName: 'ArticleDetail'
    }
  },
  components: {
    articleHead,
    iLogin,
    articleFoot
  },
  methods: {
    // 获得课程一数据
    getArticle () {
      let data = {
        new_id: this.newsId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_home_an_article',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          this.articleData = res.data.data
          this.title = res.data.data.seo_title
        })
        .catch(err => { console.log(err) })
    },
    showLogin (isShow) {
      this.loginShow = isShow
    }
  },
  mounted () {
    this.getArticle()
  }
}
</script>

<style scoped lang="stylus">
  #articledetail
    #tophead
      padding: 0 .2rem
    h3
      padding: 0 .4rem
      margin-top: .4rem
      font-size: .33rem
      font-weight: 700
      text-align: center
    .subtitle
      display: flex
      justify-content: space-between
      align-items: center
      padding: .2rem .4rem
      font-size: .2rem
    .detail
      overflow: hidden
      padding: .4rem
      >>> p
        font-size: .3rem
        img
          width: 100%
</style>



// WEBPACK FOOTER //
// src/components/article/ArticleDetail.vue